export enum ActiveView {
  None = "None",
  Statistics = "Statistics",
  CaseReport = "CaseReport",
}
